// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-input-profile-item-date-of-birth-form[data-v-7704cc14]{display:flex;justify-content:space-between}.c-input-profile-item-date-of-birth-form .m-form-select[data-v-7704cc14]{width:31.195335277%}.m-text-comments+.m-text-comments[data-v-7704cc14]{margin-top:0}", ""]);
// Exports
module.exports = exports;
